import React from 'react'

import { GetCard } from '@web/walter-lib/api'
import Details from '../Details'
import TopUp from '../TopUp'
import Freeze from '../Freeze'
import Settings from '../Settings'
import Status from './Status'
import s from './s.module.css'

interface Props {
    card?: GetCard
    isDisabled?: boolean
    setTopUpModal: (isOpen: boolean) => void
    topUpModal: boolean
}

function Actions({ card, isDisabled, setTopUpModal, topUpModal }: Props) {
    return (
        <div className={s.wrap}>
            {(card?.status === 'ACTIVE' || card?.status === 'SUSPENDED') && (
                <div className={s.actions}>
                    <TopUp
                        card={card}
                        isDisabled={isDisabled || card?.status === 'SUSPENDED'}
                        topUp={topUpModal}
                        setTopUp={setTopUpModal}
                    />
                    <Details card={card} isDisabled={isDisabled} />
                    <Freeze card={card} isDisabled={isDisabled} />
                    <Settings card={card} isDisabled={isDisabled} />
                </div>
            )}
            <Status card={card} onTopUp={() => setTopUpModal(true)} />
        </div>
    )
}

export default Actions
